import secureLocalStorage from "react-secure-storage";
import { store } from "redux/store";
import { getUserNameWithConditionalCheck } from "./SharedUtils";

export const getUserName = (getInitials = false, isCommentsPage = false) => {
  const { isImpersonated, userDetails }: any = store.getState().app.impersonationDetails;

  let firstName = secureLocalStorage.getItem("firstName")?.toString() || "";
  let lastName = secureLocalStorage.getItem("lastName")?.toString() || "";
  let displayName = secureLocalStorage.getItem("displayName")?.toString() || "";

  if (isImpersonated && !isCommentsPage) {
    firstName = userDetails.firstName;
    lastName = userDetails.lastName;
    displayName = userDetails.displayName;
  }

  if (getInitials) return displayName ? { displayName } : { firstName, lastName };

  if (isImpersonated) return userDetails.displayName || `${firstName || ""} ${lastName || ""}`;
  return getUserNameWithConditionalCheck(displayName, firstName, lastName);
};

export const getLoggedInUserDetails = (skipImpersonate: any = false) => {
  const state: any = store.getState();
  const { isImpersonated, userDetails } = state.app.impersonationDetails;
  return isImpersonated && !skipImpersonate ? userDetails : state.app.userName;
};

export const getRoleCategory = (hltIds: string[]) => {
  const list = store.getState()?.aboveProperty?.roleCategoryList || [];
  const users = hltIds?.map((id) => list.find((u: any) => u.hltId === id)).filter(Boolean);
  if (!users.length) return null;
  if (users.some((u: any) => u.lobbyUserType === "OW")) return "Leadership";
  const hasLobby = users.some((u: any) => u.lobbyUserType != null);
  const hasLeadership = users.some((u: any) => u.roleCategory === "Leadership");
  const hasRole = users.some((u: any) => u.roleCategory != null);
  if (!hasLobby) return hasLeadership ? "Leadership" : hasRole ? "Non-Leadership" : null;
  if (hasLobby && !hasRole) return null;
  return hasLeadership ? "Leadership" : hasRole ? "Non-Leadership" : null;
};

export const getPlanDetailsRoute = () => {
  const isCorp = store.getState()?.app.loggedInUserDetails.isCorp;
  return isCorp ? "inncodeplandetails" : "myplandetails";
};

export const getPlansRoute = () => {
  const isCorp = store.getState()?.app.loggedInUserDetails.isCorp;
  return isCorp ? "/inncodeplans" : "/myplans";
};
